import React, { useEffect, useState } from 'react';
import * as mentorApi from '../api/mentorApi';

export default function ProfileModal({ currentUser, onClose, onSaved, showToast }) {
  const [displayName, setDisplayName] = useState(currentUser?.name || '');
  const [phone, setPhone] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [email, setEmail] = useState(currentUser?.email || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    mentorApi.getMyProfile()
      .then((data) => {
        if (cancelled) return;
        setEmail(data?.email || currentUser?.email || '');
        setDisplayName(data?.display_name || currentUser?.name || '');
        setPhone(data?.phone || '');
        setWorkExperience(data?.work_experience || '');
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [currentUser]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const saved = await mentorApi.saveMyProfile({
        display_name: displayName || null,
        phone: phone || null,
        work_experience: workExperience || null,
      });
      if (onSaved) onSaved(saved);
      if (showToast) showToast('Profile saved on Mentor. Email stays on IFSPD login.');
      onClose();
    } catch (err) {
      if (showToast) showToast(err?.message || 'Could not save profile.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 80,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 'min(520px, 92vw)' }}>
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.2, color: '#F5941F', textTransform: 'uppercase' }}>
          Mentor profile
        </div>
        <h2 style={{ margin: '6px 0 18px', color: '#0F2557' }}>Your overlay (mentor-local)</h2>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>Email (read-only)</label>
        <input value={email} readOnly style={{ width: '100%', marginBottom: 14, padding: '8px 10px', border: '1px solid #E5E7EB', borderRadius: 8, background: '#F7F8FA', color: '#6B7280' }} />
        <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>Display name</label>
        <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} style={{ width: '100%', marginBottom: 14, padding: '8px 10px', border: '1px solid #D1D5DB', borderRadius: 8 }} />
        <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>Phone</label>
        <input value={phone} onChange={(e) => setPhone(e.target.value)} style={{ width: '100%', marginBottom: 14, padding: '8px 10px', border: '1px solid #D1D5DB', borderRadius: 8 }} />
        <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B7280', marginBottom: 6 }}>Work experience</label>
        <textarea value={workExperience} onChange={(e) => setWorkExperience(e.target.value)} rows={4} style={{ width: '100%', marginBottom: 18, padding: '8px 10px', border: '1px solid #D1D5DB', borderRadius: 8 }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" onClick={onClose} style={{ border: 'none', background: '#F1F2F4', padding: '8px 14px', borderRadius: 8, fontWeight: 700 }}>Cancel</button>
          <button type="button" onClick={handleSave} disabled={saving} style={{ border: 'none', background: '#0F2557', color: '#fff', padding: '8px 14px', borderRadius: 8, fontWeight: 700 }}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
